import {HelpPages} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getHelpStore = (store: IStore) => store.help;

export const getHelpPage = createSelector(
	[getHelpStore],
	(store) => (page: HelpPages) => store[page]
);
